import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';

import agent from '../agent'

import companyBanner from '../assets/images/check-in-expanded-01-copy-9-lukas-blazek-261681-unsplash.png'
import companyLogo from '../assets/images/check-in-expanded-01--col-company-logo@2x.png'
import project1 from '../assets/images/expanded-project-poster-2.png'
import amlogo from '../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'

class ClientLanding extends Component {

	render(){
		return (<div className="companyclientlandingpage">
            <div className="clientlanding-wrapper">
                <div className="header">
                	<div className="bg"></div>
                    <img src={companyBanner} className="lukasblazek261681unsplash" />
                    <img src={companyLogo} className="companylogo" />
                    <div className="group21">
                        <div className="auditionreviewpage">
                            AUDITION REVIEW PAGE
                        </div>
                        <div className="pleaseclickthepro">
                            PLEASE CLICK THE PROJECT BELOW &amp; ENTER THE CODE PROVIDED TO YOU, TO REVIEW YOUR AUDITIONS
                        </div>
                    </div>
                </div>
                <div className="rectangle">
                </div>



                <div className="group6">
                    <div className="group10">
                        <div className="group7copy">
                            <div className="rectangle1"></div>
                            <div className="appletvcommercial">APPLE TV COMMERCIAL</div>
                        </div>
                        <div className="teslacopy2">
                            <div className="mask"></div>
                            <img className="poster" src={project1} />
                        </div>
                    </div>
                    <div className="group10">
                    	<div className="group7copy">
                    		<div className="rectangle1"></div>
                    		<div className="appletvcommercial">TELSA TV COMMERCIAL</div>
                		</div>
                		<div className="teslacopy2">
                    		<div className="mask"></div>
                    		<img className="poster" src={project1} />
                		</div>
                    </div>
                    <div className="group10">
                        <div className="group7copy">
                            <div className="rectangle1"></div>
                            <div className="appletvcommercial">REEBOK TV COMMERCIAL</div>
                        </div>
                        <div className="teslacopy2">
                            <div className="mask"></div>
                            <img className="poster" src={project1} />
                        </div>
                    </div>
                </div>
                
                <div className="group3">
                    <img />
                    <div className="lock">
                        <img />
                        <img />
                    </div>
                </div>
                <div className="group2">
                    <div className="rectangle9copy">
                    </div>
                    <img className="auditionmagiciconplain" src={amlogo} />
                    <div className="group5">
                        <div className="poweredbyaudition">
                            Powered by Audition Magic copyright (c) 2018
                        </div>
                    </div>
                </div>
            </div>
        </div>)
	}
}

ClientLanding = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(ClientLanding)

const mapStateToProps = (state, ownProps) => {

}


const mapDispatchToProps = (dispatch) => ({
	setSignature: sig => dispatch(change( "checkinWizard", "signature", sig)),
	submitPublicRegistration: payload =>
		dispatch({ type: 'SUBMIT_CHECKIN', payload: agent.Artist.checkin(payload) })
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientLanding)


// WEBPACK FOOTER //
// ./src/containers/ClientLanding.js